import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  CCloseButton,
  CSidebar,
  CSidebarBrand,
  CSidebarHeader,
} from '@coreui/react'
import { AppSidebarNav } from './AppSidebarNav'
import navigation from './_nav'
import logo from "src/assets/images/logo.png";

const AppSidebar = ({ user }) => {
  const dispatch = useDispatch()
  const unfoldable = useSelector((state) => state.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebarShow)

  return (
    <CSidebar
      position="fixed"
      unfoldable={unfoldable}
      visible={sidebarShow}
      colorScheme="dark"
      className="
        border-end 
        shadow-lg 
        bg-dark 
        bg-opacity-90 
        backdrop-blur 
      "
      onVisibleChange={(visible) =>
        dispatch({ type: 'set', sidebarShow: visible })
      }
    >
      {/* SIDEBAR HEADER */}
      <CSidebarHeader
        className="
          bg-white 
          border-bottom 
          d-flex 
          justify-content-between 
          align-items-center 
          shadow-sm
          p-0
        "
      >
        <CSidebarBrand
          href="/"
          className="
            d-flex 
            align-items-center
          "
        >
          {/* Logo */}
          <img src={user?.logo || logo} alt="logo" style={{ width: 255 }} />
        </CSidebarBrand>

        <CCloseButton
          className="d-lg-none text-dark"
          onClick={() =>
            dispatch({ type: 'set', sidebarShow: false })
          }
        />
      </CSidebarHeader>

      {/* NAVIGATION */}
      <div
        className="px-3 py-4 overflow-auto"
        style={{ height: 'calc(100vh - 80px)' }}
      >
        <AppSidebarNav items={navigation} />
      </div>
    </CSidebar>
  )
}

export default React.memo(AppSidebar)

